/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

export const getDiscordServers = ({ limit }: any) => {
  return new Promise((resolve, reject) => {
    try {
      const servers: any = []

      let completeServers = 0
      let completeCollections = 0

      /** Create a ref collection for invalid magic eden slug */
      const discordServersSlugRef = getCollectionReference(collectionNames.DISCORD_SERVERS)

      discordServersSlugRef
        // .limit(limit + Number(10))
        .orderBy('date_added', 'desc')
        .get()
        .then(async (instance) => {
          if (instance.size > 0) {
            instance.forEach((collection: any) => {
              const discordServerData = collection.data()
              let image = null

              if (discordServerData?.status == 'complete') {
                completeServers += 1
                completeCollections += discordServerData?.slug?.length || 0
              }

              if (discordServerData.icon != null) {
                image =
                  'https://cdn.discordapp.com/icons/' +
                  discordServerData.id +
                  '/' +
                  discordServerData.icon +
                  '.png'
              }

              servers.push({
                // discord_id: discordServerData.id,
                // icon: discordServerData.icon,
                connected: discordServerData.connected,
                name: discordServerData.name,
                image_url: image,
                id: discordServerData.id,

                status: discordServerData?.status,
                channel_ids: discordServerData?.channel_ids,
                slug: discordServerData?.slug,
                // connected: discordServerData.connected,
                // status: discordServerData.status,
                // slug: discordServerData.slug,
                // channelIds: discordServerData.channelIds,
              })
            })
            console.log('SERVERS:')
            console.log(servers)
            resolve({
              collection: servers,
              limit: limit + Number(10),
              hasDataToLoad: true,
              completed_servers: completeServers,
              completed_collections: completeCollections,
            })
          } else {
            resolve({
              collection: servers,
              limit: limit + Number(10),
              hasDataToLoad: false,
              completed_servers: completeServers,
              completed_collections: completeCollections,
            })
          }
        })
    } catch (error) {
      console.log('getDiscordServers | error', error)
      reject(error)
    }
  })
}

export const updateDiscordServerField = (
  status: string,
  channel_ids: string[],
  slug: string[],
  id: string,
) => {
  return new Promise((resolve, reject) => {
    try {
      const discordServersRef = getCollectionReference(collectionNames.DISCORD_SERVERS)

      discordServersRef.doc(id).update({
        status: status,
        channel_ids: channel_ids,
        slug: slug,
      })

      resolve({ success: true, status, channel_ids, slug, id })
    } catch (error) {
      console.log('updateDiscordServerField | error', error)
      reject(error)
    }
  })
}

export const getTestList = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)
        .where('slug', '==', 'degods')
        .orderBy('created_at', 'desc')
        .get()
        .then((queryRef) => {
          console.log('queryRef', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            if (doc.data().floor_price == 0) {
              const fpPoint = {
                price_date: doc.data().price_date,
                floor_price: doc.data().floor_price,
                id: doc.id,
              }
              temp.push(fpPoint)
            }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('updateDiscordServerField | error', error)
      reject(error)
    }
  })
}

export const getDegodsFields = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)
        .where('slug', '==', 'stepn')
        .orderBy('created_at', 'desc')
        .get()
        .then((queryRef) => {
          console.log('queryRef', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const fpPoint = {
              price_date: doc.data().price_date,
              floor_price: doc.data().floor_price,
              id: doc.id,
            }
            temp.push(fpPoint)
            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('updateDiscordServerField | error', error)
      reject(error)
    }
  })
}

export const deleteDuplicateFPHistory = (duplicateList: any) => {
  return new Promise((resolve, reject) => {
    try {
      const fpHistoryRef = getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)

      // const deleteBatch = fpHistoryRef.firestore.batch()

      console.log('DELETING ' + duplicateList.length + ' DOCUMENTS')
      for (let i = 0; i < duplicateList.length; i++) {
        console.log('deleting: ', duplicateList[i])
        // deleteBatch.delete(fpHistoryRef.doc(duplicateList[i].id))
      }

      setTimeout(() => {
        // . deleteBatch.commit()

        console.log('DELETE COMPLETE')
        resolve({ success: true })
      }, 1500)
    } catch (error) {
      console.log('deleteDuplicateFPHistory | error', error)
      reject(error)
    }
  })
}

function createFirestoreBatchInstance() {
  throw new Error('Function not implemented.')
}

export const getDuplicateMagicEdenSlugsList = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('magic_eden_slug', '!=', null)
        .get()
        .then((queryRef) => {
          console.log('getDuplicateMagicEdenSlugs query ', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            temp.push(point)
            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getDuplicateMagicEdenSlugsList | error', error)
      reject(error)
    }
  })
}

export const getDuplicateMagicEdenSlugs = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getDuplicateMagicEdenSlugsList().then((list: any) => {
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (
              list[i].magic_eden_slug == list[j].magic_eden_slug &&
              list[i].id != list[j].id &&
              i < j &&
              list[i].active &&
              list[j].active
            ) {
              temp.push(list[i])
              temp.push(list[j])
            }
            if (i == list.length - 1 && j == list.length - 1) {
              resolve(temp)
            }
          }
        }
      })
    } catch (error) {
      console.log('getDuplicateMagicEdenSlugs | error', error)
      reject(error)
    }
  })
}

export const getMissingHyperspaceSlugsList = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'solana')
        .get()
        .then((queryRef) => {
          let i = 0
          queryRef.docs.map((doc) => {
            if (
              doc.data().hyperspace_slug == null &&
              doc.data().stats.market_cap > 5000 &&
              doc.data().active
            ) {
              const point = {
                id: doc.id,
                ...doc.data(),
              }
              temp.push(point)
            }

            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getMissingHyperspaceSlugsList | error', error)
      reject(error)
    }
  })
}

/*
export const deleteMagicEdenSlug = ({ id }: any) => {
  return new Promise((resolve, reject) => {
    try {
      const invalidMagicEdenSlugRef = getCollectionReference(
        collectionNames.INVALID_MAGIC_EDEN_SLUG,
      )

      invalidMagicEdenSlugRef.doc(id).delete()

      resolve({ success: true, id })
    } catch (error) {
      console.log('deleteMagicEdenSlug | error', error)
      reject(error)
    }
  })
} */

export const topSolCollectionsBrokenVolume = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'solana')
        .orderBy('stats.market_cap', 'desc')
        .limit(90)
        .get()
        .then((queryRef) => {
          let i = 0
          queryRef.docs.map(async (doc) => {
            // if (i > 90) {
            console.log('topSolCollectionsBrokenVolume doc ', doc.data())
            const brokenSOLVolume: any = await solanaFloorPriceHistoryVolumeCheck(
              doc.id,
              doc.data(),
            ) // pass doc.id and doc.data() to check if total_volume*0.1 < one_day_volume
            // if (brokenSOLVolume.length > 0) {
            const point = {
              id: doc.id,
              ...doc.data(),
              brokenVolume: brokenSOLVolume,
            }
            temp.push(point)
            // }
            if (i == queryRef.docs.length - 1) {
              console.log('topSolCollectionsBrokenVolume - ', temp)
              resolve(temp)
            }
            // }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('topSolCollectionsBrokenVolume | error', error)
      reject(error)
    }
  })
}

// Sort by Mcap, chain=solana
export const solanaFloorPriceHistoryVolumeCheck = (id: string, data: any) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)
        .where('slug', '==', data?.slug)
        .orderBy('created_at', 'desc')
        .limit(35)
        .get()
        .then((queryRef) => {
          let i = 0
          queryRef.docs.map(async (doc) => {
            const fpHistoryData = doc.data()

            if (fpHistoryData.one_day_volume > data.stats.total_volume * 0.1) {
              const point = {
                id: doc.id,
                ...doc.data(),
              }
              temp.push(point)
            }
            if (i == queryRef.docs.length - 1) {
              // console.log('getSolanaNFTsVolumeCheck - ', temp)
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSolanaNFTsVolumeCheck | error', error)
      reject(error)
    }
  })
}

export const getSolanaTopMovers = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'solana')
        .where('active', '==', true)
        .orderBy('stats.market_cap', 'desc')
        .limit(300)
        .get()
        .then((queryRef) => {
          console.log('getSolanaTopMovers query ', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            temp.push(point)
            if (i == queryRef.docs.length - 1) {
              temp.sort(
                (b: any, a: any) =>
                  a?.stats?.calculated_percent_change - b?.stats?.calculated_percent_change,
              )
              resolve(temp.slice(0, 15))
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSolanaTopMovers | error', error)
      reject(error)
    }
  })
}

export const getEthereumTopVolume = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'ethereum')
        .where('active', '==', true)
        .orderBy('stats.one_day_volume', 'desc')
        .limit(5)
        .get()
        .then((queryRef) => {
          console.log('getSolanaTopMovers query ', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            temp.push(point)
            if (i == queryRef.docs.length - 1) {
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSolanaTopMovers | error', error)
      reject(error)
    }
  })
}

export const getEthereumTopMovers = () => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'ethereum')
        .where('active', '==', true)
        .orderBy('stats.market_cap', 'desc')
        .limit(300)
        .get()
        .then((queryRef) => {
          console.log('getSolanaTopMovers query ', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            if (doc.data().stats?.floor_price > 0.01) {
              temp.push(point)
            }

            if (i == queryRef.docs.length - 1) {
              temp.sort(
                (b: any, a: any) =>
                  a?.stats?.calculated_percent_change - b?.stats?.calculated_percent_change,
              )
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSolanaTopMovers | error', error)
      reject(error)
    }
  })
}

export const getSpecificFpHistory = (slug: any, limit:number) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)
        .where('slug', '==', slug)
        .orderBy('created_at', 'desc')
        .limit(limit)
        .get()
        .then((queryRef) => {
          let i = 0
          queryRef.docs.map(async (doc) => {
            // const fpHistoryData = doc.data()

            // if (fpHistoryData.one_day_volume > data.stats.total_volume * 0.1) {
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            temp.push(point)
            // }
            if (i == queryRef.docs.length - 1) {
              // console.log('getSolanaNFTsVolumeCheck - ', temp)
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getSpecificFpHistory | error', error)
      reject(error)
    }
  })
}

export const getOldestLastUpdated = (chain: string) => {
  return new Promise((resolve, reject) => {
    try {
      const temp: any = []

      getCollectionReference(collectionNames.TOP_COLLECTIONS)
        .where('chain', '==', 'solana')
        .where('active', '==', true)
        .orderBy('last_updated_at', 'asc')
        .limit(50)
        .get()
        .then((queryRef) => {
          console.log('getOldestLastUpdated query ', queryRef)
          let i = 0
          queryRef.docs.map((doc) => {
            // console.log('DOC', doc.data())
            const point = {
              id: doc.id,
              ...doc.data(),
            }
            temp.push(point)
            if (i == queryRef.docs.length - 1) {
              /* temp.sort(
                (b: any, a: any) =>
                  a?.stats?.market_cap - b?.stats?.market_cap,
              ) */
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getOldestLastUpdated | error', error)
      reject(error)
    }
  })
}

/**
 * Used to get all BAYC floor price history fields from rarify
 * Eventually will batch delete them
 */
export const getBaycFields = () => {
  return new Promise((resolve, reject) => {
    try {
      return
      const temp: any = []

      getCollectionReference(collectionNames.FLOOR_PRICE_HISTORY)
        .where('slug', '==', 'boredapeyachtclub')
        .where('num_owners', '==', 0)
        .limit(500)
        .get()
        .then((queryRef) => {
          console.log('queryRef', queryRef)
          let i = 0
          queryRef.docs.map(async (doc) => {
            // console.log('DOC', doc.data())
            const fpPoint = {
              created_at: doc.data().created_at,
              price_date: doc.data().price_date,
              floor_price: doc.data().floor_price,
              num_owners: doc.data().num_owners,
              slug: doc.data().slug,
              id: doc.id,
            }
            temp.push(fpPoint)
            if (i == queryRef.docs.length - 1) {
              // const deleteDocs = await deleteDuplicateFPHistory(temp)
              resolve(temp)
            }
            i += 1
          })
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } catch (error) {
      console.log('getBaycFields | error', error)
      reject(error)
    }
  })
}
